module.exports = __webpack_public_path__ + "static/media/Logo.e7f81462.png";